import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { AppDispatch } from 'src/redux/store';
import HomeIcon from 'src/assets/images/Home-icon.svg';
import TimelineIcon from 'src/assets/images/Timeline-icon.svg';
import TeamIcon from 'src/assets/images/Team-icon.svg';
import MembersIcon from 'src/assets/images/Members-icon.svg';
import FolderIcon from 'src/assets/images/Folder-icon.svg';
import GetFeedbackIcon from 'src/assets/images/Get-Feedback-icon.svg';
import UpdateIcon from 'src/assets/images/Update-icon.svg';
import ReportIcon from 'src/assets/images/Report-icon.svg';
import AttendIcon from 'src/assets/images/Attends-icon.svg';
import SettingIcon from 'src/assets/images/Setting-icon.svg';
import { twMerge } from 'tailwind-merge';

interface IMenuItemProps {
  link: string;
  icon: string;
  iconAlt: string;
  onClick?: any;
  tooltip?: string;
  text?: string;
}
interface IMenuRoutes {
  link: string;
  iconAlt: string;
  icon: any;
  tooltip: string;
  text: string;
}

const Index = () => {
  const routes: IMenuRoutes[] = [
    {
      link: '/',
      icon: HomeIcon,
      iconAlt: 'home icon',
      tooltip: 'Dashboard',
      text: 'Dashboard',
    },
    {
      link: '/team-builder',
      icon: TeamIcon,
      iconAlt: 'teambuilder icon',
      tooltip: 'Team Builder',
      text: 'Team Builder',
    },
    {
      link: '/timeline',
      icon: TimelineIcon,
      iconAlt: 'timeline icon',
      tooltip: 'Timeline',
      text: 'Timeline',
    },
    {
      link: '/members',
      icon: MembersIcon,
      iconAlt: 'member icon',
      tooltip: 'Members',
      text: 'Members',
    },
    {
      link: '/projects',
      icon: FolderIcon,
      iconAlt: 'projects icon',
      tooltip: 'Projects',
      text: 'Projects',
    },
    {
      link: '/get-feedback',
      icon: GetFeedbackIcon,
      iconAlt: 'feedback icon',
      tooltip: 'Get Feedback',
      text: 'Get Feedback',
    },
    {
      link: '/get-updates',
      icon: UpdateIcon,
      iconAlt: 'updates icon',
      tooltip: 'Get Updates',
      text: 'Get Updates',
    },
    {
      link: '/reports',
      icon: ReportIcon,
      iconAlt: 'report icon',
      tooltip: 'Reports',
      text: 'Reports',
    },
    {
      link: '/attendance',
      icon: AttendIcon,
      iconAlt: 'attend icon',
      tooltip: 'Attendance',
      text: 'Attendance',
    },
    {
      link: '/settings',
      icon: SettingIcon,
      iconAlt: 'setting icon',
      tooltip: 'Settings',
      text: 'Settings',
    },
  ];

  return (
    <>
      {routes.map(
        (
          { link, icon, iconAlt = 'menu-item-icon', text }: IMenuItemProps,
          index: number
        ) => (
          <NavLink
            to={link}
            className={({ isActive }) =>
              twMerge(
                'h-14 flex flex-col items-center justify-center bg-white hover:bg-gray-100',
                isActive &&
                  'bg-gradient-to-br from-indigo-700 via-sky-600 to-cyan-500'
              )
            }
            key={`${link}+${index}`}
          >
            <div
              className={twMerge(
                'text-center text-blue-950 text-xs font-normal font-SFProDisplay',
                window.location.pathname === link && 'text-white'
              )}
            >
              <img
                src={icon}
                alt={iconAlt}
                className={twMerge(
                  'mx-auto mb-1',
                  window.location.pathname === link
                    ? 'filter brightness-0 invert'
                    : ''
                )}
              />
              {text}
            </div>
          </NavLink>
        )
      )}
    </>
  );
};

export default Index;
